import { useState, useRef, useEffect } from "react";
import { TabScrollButton } from "@mui/material";
import { tss } from "tss-react";

var useStyles = tss.create({
    root: {
        display: "inline-flex",
        alignItems: "center",
        height: "100%",
        overflow: "hidden",
        width: "100%",
    },
    arrow: {},
});

var nodeRef: any, leftRef: any, rightRef: any;
const delimiter = 20,
    panelWidth = 300;
var leftScroll = 0;

type IProps = {
    children?: any;
};

export default function ArrowsScrollbar(props: IProps) {
    const { classes } = useStyles();
    var { children } = props;
    nodeRef = useRef(null);
    leftRef = useRef(null);
    rightRef = useRef(null);

    const width = useRef<number>(0);
    var intervalId: any;
    var [currentWidth, setCurrentWidth] = useState(300);
    var [spacing, setSpacing] = useState(0);
    useEffect(() => {
        var handleResize = () => {
            const { current: prevWidth } = width;
            const { clientWidth = 0, scrollWidth = 0 } = nodeRef.current ?? {};
            width.current = scrollWidth - clientWidth + panelWidth;
            if (prevWidth !== width.current) {
                //console.log('current:', width.current);
                setCurrentWidth(width.current);
            }
            if (nodeRef && nodeRef.current && nodeRef.current != null) {
                leftScroll = nodeRef.current.scrollLeft;
            }
            if (width.current > panelWidth) {
                setSpacing(90);
            } else {
                setSpacing(0);
            }
        };

        window.addEventListener("resize", handleResize);
        handleResize();
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    var stopScroll = () => {
        clearTimeout(intervalId);
    };

    var scrollLeft = () => {
        if (nodeRef && nodeRef.current) {
            nodeRef.current.scrollLeft = leftScroll > delimiter ? leftScroll - delimiter : 0;
            leftScroll = leftScroll > delimiter ? nodeRef.current.scrollLeft - delimiter : 0;
            stopScroll();
            intervalId = setTimeout(scrollLeft, 100);
        }
    };
    var scrollRight = () => {
        if (nodeRef && nodeRef.current) {
            nodeRef.current.scrollLeft = leftScroll + delimiter;
            leftScroll = nodeRef.current.scrollLeft + delimiter;
            stopScroll();
            intervalId = setTimeout(scrollRight, 100);
            if (leftRef && leftRef.current !== null) {
                leftRef.current.style.display = "inline-flex";
            }
        }
    };
    return (
        <div className={classes.root}>
            <TabScrollButton
                ref={leftRef}
                orientation="horizontal"
                direction="left"
                className={classes.arrow}
                style={{
                    display: leftScroll === 0 ? "none" : "inline-flex",
                    color: "white",
                }}
                onMouseOver={scrollLeft}
                onMouseOut={stopScroll}
            />
            <div
                ref={nodeRef}
                style={{
                    display: "inline-flex",
                    overflow: "hidden",
                    width: "calc( 100% - " + spacing + "px)",
                }}
            >
                {children}
            </div>
            <TabScrollButton
                ref={rightRef}
                orientation="horizontal"
                direction="right"
                className={classes.arrow}
                style={{
                    display: currentWidth === panelWidth ? "none" : "inline-flex",
                    position: "absolute",
                    right: 0,
                    color: "white",
                }}
                onMouseOver={scrollRight}
                onMouseOut={stopScroll}
            />
        </div>
    );
}
